import React, { useMemo, useState } from 'react';
import Select from '../../components/Select/Select';
import Button from '../../components/Button/Button';
import {
  groupComplectationRows,
  complectationOptions,
  defaultAnswer,
  buildComplectationResolution,
  NEW_COMPLECTATION,
} from './complectationGroups';
import styles from './complectationQuestions.module.css';

const carsWord = (n) => {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return 'Ð¼Ð°ÑÐ¸Ð½Ð°';
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return 'Ð¼Ð°ÑÐ¸Ð½Ñ';
  return 'Ð¼Ð°ÑÐ¸Ð½';
};

// ÐÐµÑÐ²ÑÐ¹ ÑÐ°Ð³ ÑÑÑÐ½Ð¾Ð¹ Ð¿ÑÐ°Ð²ÐºÐ¸: Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¹ Ð¸Ð· Ð²ÑÐ³ÑÑÐ·ÐºÐ¸, ÐºÐ¾ÑÐ¾ÑÑÑ Ð½ÐµÑ Ð²
// ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ. ÐÐ¾ Ð¾Ð´Ð½Ð¾Ð¹ ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð½Ð° Â«Ð¼Ð¾Ð´ÐµÐ»Ñ + Ð½Ð°Ð·Ð²Ð°Ð½Ð¸ÐµÂ»; Ð¾ÑÐ²ÐµÑ Ð·Ð°Ð¿Ð¾Ð¼Ð¸Ð½Ð°ÐµÑÑÑ
// Ð½Ð° Ð±ÑÐºÐµ (Ð°Ð»Ð¸Ð°Ñ) Ð¸ Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ ÑÐ¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÑÑÑ
const ComplectationQuestions = ({ rows, onCommit }) => {
  const groups = useMemo(() => groupComplectationRows(rows), [rows]);
  const [answers, setAnswers] = useState({});
  const [busy, setBusy] = useState(() => new Set());

  const answerOf = (group) => (group.key in answers ? answers[group.key] : defaultAnswer(group));

  const apply = async (toApply) => {
    const resolutions = toApply.flatMap((group) =>
      group.rows.map((row) => buildComplectationResolution(row, answerOf(group)))
    );
    if (resolutions.length === 0) return;
    const keys = toApply.map((g) => g.key);
    setBusy((prev) => new Set([...prev, ...keys]));
    try {
      await onCommit(resolutions);
    } finally {
      setBusy((prev) => {
        const next = new Set(prev);
        keys.forEach((k) => next.delete(k));
        return next;
      });
    }
  };

  const ready = groups.filter((g) => answerOf(g) && !busy.has(g.key));

  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <div className={styles.hint}>
          Ð­ÑÐ¸Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¹ Ð½ÐµÑ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ Ð¼Ð¾Ð´ÐµÐ»Ð¸. ÐÑÐ±ÐµÑÐ¸ÑÐµ, ÐºÐ°ÐºÐ¾Ð¹ Ð¸Ð· ÑÑÑÐµÑÑÐ²ÑÑÑÐ¸Ñ Ð¾Ð½Ð¸ ÑÐ¾Ð¾ÑÐ²ÐµÑÑÑÐ²ÑÑÑ, â Ð¸Ð»Ð¸ Ð·Ð°Ð²ÐµÐ´Ð¸ÑÐµ
          Ð½Ð¾Ð²ÑÑ.
        </div>
        <Button
          fill
          text={`ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐµ (${ready.length})`}
          onClick={() => apply(ready)}
          disabled={ready.length === 0}
        />
      </div>

      {groups.map((group) => {
        const answer = answerOf(group);
        const isBusy = busy.has(group.key);
        return (
          <div key={group.key} className={styles.card}>
            <div className={styles.cardInfo}>
              <div className={styles.cardTitle}>{group.title || 'Ð±ÐµÐ· Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ñ'}</div>
              <div className={styles.cardMeta}>
                {group.markName} {group.modelName} Â· {group.rows.length} {carsWord(group.rows.length)}
              </div>
            </div>
            <div className={styles.cardSelect}>
              <Select
                placeholder="ÐÑÐ±ÐµÑÐ¸ÑÐµ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ"
                options={complectationOptions(group)}
                value={answer}
                disabled={isBusy}
                onChange={(val) => setAnswers((prev) => ({ ...prev, [group.key]: val }))}
              />
              {answer?.value === NEW_COMPLECTATION && (
                <div className={styles.newHint}>
                  ÐÐ¾Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ ÑÐ¾Ð·Ð´Ð°ÑÑÑÑ Ð¿ÑÑÑÐ¾Ð¹ â Ð¾ÑÐ½Ð°ÑÐµÐ½Ð¸Ðµ Ð¿ÑÐ¸Ð´ÑÑÑÑ Ð·Ð°Ð¿Ð¾Ð»Ð½Ð¸ÑÑ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ
                </div>
              )}
            </div>
            <div className={styles.cardButton}>
              <Button
                fill
                text={isBusy ? 'ÐÑÐ¸Ð¼ÐµÐ½ÑÐµÑÑÑâ¦' : 'ÐÑÐ¸Ð¼ÐµÐ½Ð¸ÑÑ'}
                onClick={() => apply([group])}
                disabled={!answer || isBusy}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ComplectationQuestions;
